import { canv } from '@/canv/global.js'

export class shapeBraceRight {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 18/20 - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width * 2/20 + width * 18/20 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y);
        canv.ctx.arcTo(x + width/20, y + height * 1/20, x + width/20, y + height/2, width / 20);
        canv.ctx.lineTo(x + width/20, y + height * 9/20);
        canv.ctx.lineTo(x + width * 2/20, y + height * 10/20);
        canv.ctx.lineTo(x + width/20, y + height * 11/20);
        canv.ctx.lineTo(x + width/20, y + height * 19/20);
        canv.ctx.arcTo(x + width/20, y + height * 19/20, x, y + height, width / 20);
        canv.ctx.lineTo(x, y + height);
    }

    getAvatar(color) {
        return `
        <svg width="37" height="88" viewBox="0 0 37 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.000267506 84H3.63663C7.49445 84 11.1941 82.4676 13.9217 79.7396C16.6497 77.012 18.1821 73.3124 18.1821 69.4545V58.5455C18.1821 55.6524 19.3315 52.8775 21.3774 50.8316C23.4231 48.7858 26.1979 47.6364 29.0912 47.6364C30.0556 47.6364 30.9805 47.2531 31.6625 46.5713C32.3444 45.8895 32.7275 44.9644 32.7275 44C32.7275 43.0356 32.3444 42.1105 31.6625 41.4287C30.9805 40.7469 30.0556 40.3636 29.0912 40.3636C26.1979 40.3636 23.4231 39.2142 21.3774 37.1684C19.3315 35.1226 18.1821 32.3478 18.1821 29.4545V18.5455C18.1821 14.6877 16.6497 10.9881 13.9217 8.26025C11.1941 5.53247 7.49445 4 3.63663 4H0.000267506"
        stroke="` + color + `" stroke-width="7"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 11 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.000266433 26H1.13663C2.3422 26 3.49833 25.5211 4.35072 24.6686C5.20322 23.8162 5.68208 22.6601 5.68208 21.4545V18.0455C5.68208 17.1414 6.04129 16.2742 6.68061 15.6349C7.31991 14.9956 8.18703 14.6364 9.09118 14.6364C9.39256 14.6364 9.6816 14.5166 9.89471 14.3035C10.1078 14.0905 10.2275 13.8014 10.2275 13.5C10.2275 13.1986 10.1078 12.9095 9.89471 12.6965C9.6816 12.4834 9.39256 12.3636 9.09118 12.3636C8.18703 12.3636 7.31991 12.0044 6.68061 11.3651C6.04129 10.7258 5.68208 9.85869 5.68208 8.95455V5.54545C5.68208 4.33992 5.20322 3.18377 4.35072 2.33133C3.49833 1.4789 2.3422 1 1.13663 1H0.000266433" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
